import dependencies, {
  menuNavigationDependencies,
} from '../generated/feature-permissions';

/** 只补齐所属功能的查看入口，具体写操作始终使用自身权限。 */
export const featureReadDependencies: Record<string, string[]> = dependencies;

export function featureNavigation(granted: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(featureReadDependencies).map(([code, actions]) => [
      code,
      Boolean(granted[code] || actions.some((action) => granted[action])),
    ]),
  );
}

/** 分组只补齐导航，不把父菜单或相邻菜单转成业务授权。 */
export function menuNavigation(granted: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(menuNavigationDependencies).map(([code, children]) => [
      `menu:${code}`,
      Boolean(
        granted[`menu:${code}`] || children.some((child) => granted[child]),
      ),
    ]),
  );
}
